module.exports = __webpack_public_path__ + "static/media/v2m.76629e70.mp4";